import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const getDefaultState = () => {
    let ownCampaign = false
    if (typeof window !== 'undefined' && window.localStorage && window.localStorage.getItem('ownCampaign') !== null) {
        ownCampaign = window.localStorage.getItem('ownCampaign') === 'true'
    }

    return {
        displayMode: 'CARD',
        search: null,
        campaignType: ['CMAJ', 'CADH'],
        archived: false,
        ownCampaign: ownCampaign
    }
}

const campaignFilter = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setDisplayMode(state, value) {
            state.displayMode = value
        },
        setSearch(state, value) {
            state.search = value
        },
        setCampaignType(state, value) {
            state.campaignType = value
        },
        setArchived(state, value) {
            state.archived = value
        },
        setOwnCampaign(state, value) {
            state.ownCampaign = value
        },
        removeCampaignType(state, index) {
            state.campaignType.splice(index, 1)
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default campaignFilter